import { render, staticRenderFns } from "./simple-core-values.vue?vue&type=template&id=e2566c24&scoped=true"
import script from "./simple-core-values.vue?vue&type=script&lang=js"
export * from "./simple-core-values.vue?vue&type=script&lang=js"
import style0 from "./simple-core-values.vue?vue&type=style&index=0&id=e2566c24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2566c24",
  null
  
)

export default component.exports